import React from 'react';
import HighlightText from '../HomePage/HighlightText';
import CTAButton from "../HomePage/Button";

function LearningGrid(props) {
    const LearningGridArray = [
        {
            order: -1,
            heading: "World-Class Learning for",
            highlightText: "Anyone, Anywhere",
            description: "Studynotion partners with more than 275+ leading universities and companies to bring flexible, affordable, job-relevant online learning to individuals and organizations worldwide.",
            BtnText: "Learn More",
            BtnLink: "/",
        },
        {
            order: 1,
            heading: "Curriculum Based on Industry Needs",
            description: "Save time and money! The Belajar curriculum is made to be easier to understand and in line with industry needs.",
        },
        {
            order: 2,
            heading: "Our Learning Methods",
            description: "The learning process uses the namely online and offline.",
        },
        {
            order: 3,
            heading: "Certification",
            description: "You will get a certificate that can be used as a certification during job hunting.",
        },
        {
            order: 4,
            heading: '"Rating Auto-grading"',
            description: "You will immediately get feedback during the learning process without having to wait for an answer or response from the mentor.",
        },
        {
            order: 5,
            heading: "Ready to Work",
            description: "Connected with over 150+ hiring partners, you will have the opportunity to find a job after graduating from our program.",
        },
    ]
    return (
        <div className='grid md:grid-cols-4 max-[450px]:grid-cols-1 max-[450px]:gap-5 max-[450px]:p-4 mb-10 mt-14 '>
            {
                LearningGridArray.map((card,index)=> {
                    return (
                        <div key={index} className={`${index === 0 && ("md:col-span-2 md:h-[14rem]")}  ${card.order % 2 === 0 ? ("bg-richblack-800 md:h-[14rem]") : ("bg-richblack-600")} ${card.order === 3 && "md:col-start-2"} text-richblack-50` }>
                            {
                                card.order < 0 ? (
                                    <div className='bg-richblack-900'>
                                        <div className='text-3xl w-[50%]'>{card.heading}
                                        <HighlightText text={card.highlightText}/>
                                        </div>
                                            <p className='w-[80%] mt-2'>
                                                {
                                                    card.description
                                                }
                                            </p>
                                            <div className='w-fit mt-8'>
                                                <CTAButton active={true} linkto={"/"}>Learn More</CTAButton>
                                            </div>
                                    </div>
                                ) : (
                                    <div className='p-5 flex flex-col gap-5 '>
                                        <div className='text-lg font-medium'>{card.heading}</div>
                                        <div className='text-sm'>{card.description}</div>
                                    </div>
                                )
                            }
                        </div>
                    )
                })
            }
        </div>
    );
}

export default LearningGrid;